<template>
  <div class="filter-block-time flex flex--column">
    <label for="filter-block-time">שעת תחילת בלוק מבוקשת:</label>
    <select2 dir="rtl" :value="value" :isBlockRange="true">
      <option
        v-for="option in selectOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select2>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      selectOptions: [
        { text: "בחר", value: "" },
        { text: "07:00-12:00", value: `["7", "12"]` },
        { text: "12:00-17:00", value: `["12", "17"]` },
        { text: "17:00-22:00", value: `["17", "22"]` }
      ],
      selected: ""
    };
  }
};
</script>
